import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { noStorageService } from 'services/noStorageService';
import { parseApiError } from 'utils/errorParser';

export const fetchNoStorage = createAsyncThunk('noStorage/fetch', async (params, { rejectWithValue }) => {
  try {
    return await noStorageService.list(params);
  } catch (error) {
    return rejectWithValue(parseApiError(error));
  }
});

const noStorageSlice = createSlice({
  name: 'noStorage',
  initialState: { items: [], total: 0, status: 'idle', error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNoStorage.pending, (state) => { state.status = 'loading'; })
      .addCase(fetchNoStorage.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload.items;
        state.total = action.payload.total;
      })
      .addCase(fetchNoStorage.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload?.message;
      });
  },
});

export default noStorageSlice.reducer;
